<template>
  <!-- Stream -->
  <div v-if="joinStatus">
    <session-component
      :sessionId="sessionId"
      :apiKey="apiKey"
      :token="token"
      :publisher="false"
      @streamDestroyed="streamDestroyed"
    />
  </div>

  <!-- Loading -->
  <v-layout v-else-if="loading && !streamDestroyedStatus" class="mt-16">
    <loading-progress :status="loading" />
  </v-layout>

  <!-- Stream End Info -->
  <v-layout v-else-if="!loading && streamDestroyedStatus" class="mt-16">
    Yayın sonlanmıştır.
    <v-btn @click="close"> Tamam </v-btn>
  </v-layout>
</template>

<script>
import BroadcastService from "../../services/BroadcastService";
import SessionComponent from "../../components/LiveStream/Session.vue";
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import moment from "moment";
export default {
  data() {
    return {
      startStatus: false,
      sessionId: null,
      apiKey: null,
      token: null,
      user: null,
      startDate: null,
      broadcastId: null,
      streamDestroyedStatus: false,
      loading: true,
    };
  },
  mounted() {
    console.log("broadcastId :", this.$route.params.id);
    if (this.$route.params.id) {
      this.getStream(this.$route.params.id);
    } else {
      window.showInfo("Canlı yayın bulunamadı", "standart", "error");
      this.router.push({ path: `/home` });
    }
  },
  components: {
    SessionComponent,
    LoadingProgress,
  },
  methods: {
    getStream(id) {
        this.loading = true
      BroadcastService.getOnGoingBroadcasts(id)
        .then((res) => {
          if (res.data.length > 0) {
            this.apiKey = res.data[0].ApiKey.toString();
            this.sessionId = res.data[0].SessionId;
            this.token = res.data[0].Token;
            this.user = res.data[0].User;
            this.startDate = moment(res.data[0].CreatedAt).fromNow();
            this.broadcastId = res.data[0].BroadcastId;
            this.sendBroadCastJoinInfo(res.data[0].BroadcastId)
          } else {
            this.streamDestroyed()
            console.log("Res data is empty");
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.startStatus = true;
          this.loading = false;
        });
    },

    sendBroadCastJoinInfo(id) {
      BroadcastService.sendBroadCastJoinInfo(id)
        .then((res) => {})
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },

    streamDestroyed() {
      console.log("streamDestroyeddd");
      this.startStatus = false;
      this.apiKey = null;
      this.sessionId = null;
      this.token = null;

      this.loading = false;

      this.streamDestroyedStatus = true
    },

    close() {
      this.startStatus = false;
      this.sessionId = null;
      this.apiKey = null;
      this.token = null;
      this.user = null;
      this.startDate = null;
      this.broadcastId = null;
      this.streamDestroyedStatus = false;
      this.loading = false;
      this.$router.push("/home");
    },
  },
  computed: {
    joinStatus() {
      if (this.startStatus && this.apiKey && this.sessionId && this.token && !this.loading) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
};
</script>
